import _Array$from from 'babel-runtime/core-js/array/from';
import _Map from 'babel-runtime/core-js/map';
export var devices = ['mobile', 'tablet', 'desktop', 'native'];
export var defaultDevice = 'mobile';

export var sizesDefinition = new _Map([[100, { min: 0, max: 360 }], [200, { min: 360, max: 480 }], [300, { min: 480, max: 768 }], [400, { min: 768, max: 1024 }], [500, { min: 1024, max: 1280 }], [600, { min: 1280, max: 1366 }], [700, { min: 1366, max: 1600 }], [800, { min: 1600, max: Infinity }]]);

export var sizes = _Array$from(sizesDefinition.keys());

export var defaultSize = 100;